import React, { FC, useEffect } from "react";
import { AuthRouter } from "@modules/Authentication/Containers/Router/Router";
import { ServiceOffersConfirmationMessagesRouter } from "@modules/ServiceAssignment/Containers/ConfirmationMessagesRouter/ConfirmationMessagesRouter";
import { Routes } from "@Libs/Router/Components/Routes/Routes";
import { Route } from "@Libs/Router/Components/Route/Route";
import { useLocation } from "@Libs/Router/hooks/useLocation";
import { GenericSubscriptionFlow } from "@modules/Subscriptions/Containers/GenericSubscriptionFlow/GenericSubscriptionFlow";
import { ServiceOfferAcceptanceFlowRouter } from "@modules/ServiceAssignment/Containers/ServiceOfferAcceptanceFlow/Router/Router";
import { ServiceOfferClosureFlowRouter } from "@modules/ServiceProcessing/Containers/ServiceOfferClosureFlow/Router";
import { ServiceProviderMetricsRouter } from "@modules/ServiceProviders/Containers/ServiceProviderMetricsRouter/Router";
import { ServiceProviderPhotoBookRouter } from "@modules/ServiceProviders/Containers/PhotoBookRouter/Router";
import { ServiceRequest } from "@modules/ServiceRequest/Containers/ServiceRequestRouter/Router";
import { IServiceRequest } from "@modules/ServiceRequest/types";
import { serviceRequestPathFragment } from "@modules/ServiceRequest/config/routes";

export const Router: FC = (props) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Routes>
      <Route fragments="USERS" withLocale matchAny element={<AuthRouter />} />
      <Route
        fragments="SUBSCRIBE"
        withLocale
        matchAny
        private
        element={<GenericSubscriptionFlow />}
      />
      <Route
        fragments={["SERVICE_OFFERS", "SERVICE_OFFER", "ACCEPTANCE"]}
        withLocale
        matchAny
        private
        element={<ServiceOfferAcceptanceFlowRouter />}
      />
      <Route
        fragments={["SERVICE_OFFERS", "SERVICE_OFFER", "CLOSE"]}
        withLocale
        matchAny
        private
        element={<ServiceOfferClosureFlowRouter />}
      />
      <Route
        fragments="LEGACY_SERVICE_OFFER_FLOWS_CONFIRMATION_PAGE"
        withLocale
        private
        element={<ServiceOffersConfirmationMessagesRouter />}
      />
      <Route
        fragments={["SUPERTALENT_OBJECTIVES"]}
        withLocale
        matchAny
        private
        element={<ServiceProviderMetricsRouter />}
      />
      <Route
        fragments={["PHOTO_BOOK"]}
        withLocale
        private
        element={<ServiceProviderPhotoBookRouter />}
      />
      <Route
        fragments={[serviceRequestPathFragment.SERVICE_REQUEST]}
        withLocale
        private
        element={
          <ServiceRequest
            state={{ serviceRequest: props as IServiceRequest }}
            backRoute={{ to: ["CLIENT_DASHBOARD"] }}
          />
        }
      />
    </Routes>
  );
};
